import { Link, Message } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { TestResultsDestinationInjectedProviderProps } from './types';

let OtherImportWorksheetTestResultsDestinations: React.FC<TestResultsDestinationInjectedProviderProps> = ({
  readableWorksheets,
  imports,
}) => {
  return (
    <Message>
      The results of this test have been exported to the following test{imports.length > 1 ? 's' : ''}:
      <ul>
        {imports.map(({ SampleId, LinkId, WorksheetType }: any, index: number) => (
          <li key={index}>
            {readableWorksheets.includes(WorksheetType.Id) ? (
              <Link to={`/worksheets/${LinkId}`}>
                {WorksheetType.Caption} on {SampleId}
              </Link>
            ) : (
              `${WorksheetType.Caption} on ${SampleId}`
            )}
          </li>
        ))}
      </ul>
      When results on this test are updated, they must be manually re-imported to{' '}
      {imports.length > 1 ? ' these tests' : ' this test'}.
    </Message>
  );
};

OtherImportWorksheetTestResultsDestinations = withInjectedProps(OtherImportWorksheetTestResultsDestinations);

export { OtherImportWorksheetTestResultsDestinations };
export default OtherImportWorksheetTestResultsDestinations;
